module.exports = __webpack_public_path__ + "static/media/message_icon.d542a234.png";